<template>
  <div class="t-lk-promotions t-lk-requests-view">
    <div class="t-lk-container">
      <link-back-cmp
        v-animation:bottom.delay
        class="t-lk-container-mobile"
        :btn="$root.staticText.lk.requestsTitle"
        link-name="lk-requests"
      >
      </link-back-cmp>

      <div class="t-lk-requests-view__container">
        <div class="t-lk-requests-view__left">
          <div v-if="info" v-animation:bottom.delay class="t-lk-requests-view-message">
            <div class="t-lk-requests-view__row">
              <div class="t-lk-requests-view__date">{{ info.date }}</div>
              <div v-if="info.status === 'wait'" class="t-lk-requests-view__status _wait">
                {{ $root.staticText.lk.requestsStatusWait }}
              </div>
              <div v-else-if="info.status === 'done'" class="t-lk-requests-view__status _done">
                {{ $root.staticText.lk.requestsStatusDone }}
              </div>
              <div v-else-if="info.status === 'answer'" class="t-lk-requests-view__status _done">
                {{ $root.staticText.lk.requestsStatusAnswer }}
              </div>
            </div>
            <h1 class="t-lk-requests-view__title">{{ info.title }}</h1>
            <div class="t-lk-requests-view-message__desc t-html" v-html="info.description"></div>
          </div>

          <div
            v-if="isMobile"
            v-animation:bottom.delay
            class="t-lk-requests-view__modal-btn"
            @click="
              modalType_requestContactOpen({
                manager: manager,
                managerImg: managerImg,
                phone: phone,
                email: email,
              })
            "
          >
            {{ $root.staticText.lk.contactsAxoft }}
          </div>

          <div v-animation:bottom.delay v-for="item in messages" class="t-lk-requests-view-message" :class="{ _green: item.manager }">
            <div class="t-lk-requests-view-message__wrap">
              <div class="t-lk-requests-view-message__left">
                <div class="t-lk-requests-view-message__img" :class="{ _manager: item.manager }">
                  <span>{{ item.name.split(' ')[0][0] + item.name.split(' ')[1][0] }}</span>
                  <img v-if="item.manager" src="/dist/img/logo-small.png" alt="" />
                </div>
                <div class="t-lk-requests-view-message__right">
                  <div v-if="!item.manager" class="t-lk-requests-view-message__subtitle">
                    {{ $root.staticText.lk.you }}
                  </div>
                  <div class="t-lk-requests-view-message__name">{{ item.name }}</div>
                  <div v-if="isMobile" class="t-lk-requests-view-message__date">{{ item.date }}</div>
                </div>
              </div>
              <div v-if="!isMobile" class="t-lk-requests-view-message__date">{{ item.date }}</div>
            </div>
            <div class="t-lk-requests-view-message__desc t-html" v-html="item.text"></div>
            <div v-if="item.files && item.files.length > 0" class="t-lk-requests-view__files _top">
              <lk-file-cmp
                v-for="(file, index) in item.files"
                :key="'requests-view-file2' + index"
                :file="file"
                :is-download="true"
                @delete-file="deleteFile(index)"
              >
              </lk-file-cmp>
            </div>
          </div>

          <div v-animation:bottom.delay class="t-lk-requests-view-message t-lk-requests-view-form">
            <form class="t-form" :class="{ _disabled: infoForm.disabledForm }" @submit.stop.prevent="submitForm()">
              <div v-for="(item, index) in cmpForm" class="t-form__item">
                <textarea
                  v-if="item.type === 'textarea'"
                  :class="{ _error: item.error, _valid: item.valid }"
                  class="t-textarea"
                  :placeholder="item.hintField"
                  v-model="item.value"
                  @focus="focusForm(index)"
                >
                </textarea>
              </div>
              <div v-if="files.length > 0" class="t-lk-requests-view__files">
                <lk-file-cmp
                  v-for="(item, index) in files"
                  :key="'requests-view-file' + index"
                  :file="item"
                  :is-delete="true"
                  @delete-file="deleteFile(index)"
                >
                </lk-file-cmp>
              </div>
              <label for="requests-file" class="t-lk-requests-view-form__input">
                <input type="file" name="requests-file" id="requests-file" @change="changeFile($event)" />
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M21.44 11.0499L12.25 20.2399C11.1241 21.3658 9.59717 21.9983 8.00498 21.9983C6.4128 21.9983 4.88583 21.3658 3.75998 20.2399C2.63414 19.1141 2.00165 17.5871 2.00165 15.9949C2.00165 14.4027 2.63414 12.8758 3.75998 11.7499L12.95 2.55992C13.7005 1.80936 14.7185 1.3877 15.78 1.3877C16.8414 1.3877 17.8594 1.80936 18.61 2.55992C19.3605 3.31048 19.7822 4.32846 19.7822 5.38992C19.7822 6.45138 19.3605 7.46936 18.61 8.21992L9.40998 17.4099C9.0347 17.7852 8.52571 17.996 7.99498 17.996C7.46426 17.996 6.95527 17.7852 6.57998 17.4099C6.2047 17.0346 5.99387 16.5256 5.99387 15.9949C5.99387 15.4642 6.2047 14.9552 6.57998 14.5799L15.07 6.09992"
                    stroke="#9FA2AC"
                    stroke-width="1.6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span>{{ $root.staticText.lk.requestsFile }}</span>
              </label>

              <vue-recaptcha
                ref="recaptcha"
                size="invisible"
                :sitekey="$root.sitekeyRecaptcha"
                :load-recaptcha-script="true"
                @verify="onCapchaRegister"
                @expired="onCaptchaExpired"
                @error="errorCaptcha"
              />
              <button class="t-btn _lk _border-green">{{ $root.staticText.forms.btn }}</button>
            </form>
          </div>
        </div>

        <div v-if="!isMobile" v-animation:bottom.delay class="t-lk-requests-view__right">
          <div v-if="manager" class="t-lk-requests-view-manager">
            <div class="t-lk-requests-view-manager__img">
              <img v-if="managerImg" :src="managerImg" :alt="$root.staticText.lk.requestsManager" />
            </div>
            <h2 class="t-lk-requests-view__title">{{ $root.staticText.lk.requestsManager }}</h2>
          </div>
          <div v-else class="t-lk-requests-view-contacts">
            <div class="t-lk-requests-view-contacts__title">{{ $root.staticText.lk.contacts }}</div>
            <h2 class="t-lk-requests-view__title">{{ $root.staticText.lk.contactsAxoft }}</h2>
          </div>

          <div class="t-lk-requests-view__content">
            <div class="t-lk-requests-view__contact">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3 5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H8.28C8.48979 3.00016 8.69422 3.0663 8.86436 3.18905C9.03449 3.3118 9.1617 3.48496 9.228 3.684L10.726 8.177C10.8019 8.40534 10.7929 8.65339 10.7007 8.87564C10.6085 9.0979 10.4393 9.27945 10.224 9.387L7.967 10.517C9.07332 12.9655 11.0345 14.9267 13.483 16.033L14.613 13.776C14.7205 13.5607 14.9021 13.3915 15.1244 13.2993C15.3466 13.2071 15.5947 13.1981 15.823 13.274L20.316 14.772C20.5152 14.8383 20.6885 14.9657 20.8112 15.136C20.934 15.3064 21.0001 15.511 21 15.721V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H18C9.716 21 3 14.284 3 6V5Z"
                  stroke="#C0C0CC"
                  stroke-width="1.4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div class="t-lk-requests-view__subtext">{{ $root.staticText.forms.phone }}</div>
              <a :href="'tel:' + phone" class="t-lk-requests-view__link">{{ phone }}</a>
            </div>
            <div class="t-lk-requests-view__contact">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19Z"
                  stroke="#C0C0CC"
                  stroke-width="1.4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div class="t-lk-requests-view__subtext">{{ $root.staticText.forms.email }}</div>
              <a :href="'mailto:' + email" class="t-lk-requests-view__link">{{ email }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import linkBack from '@components/lk/link-back/link-back.vue'
import lkFile from '@components/lk/lk-file/lk-file.vue'
import { mapActions, mapState } from 'vuex'
import onScrollAnimate from '@assets/js/scrollAnimate.js'
import VueRecaptcha from 'vue-recaptcha'
import { router } from '@src/routes'

export default {
  name: 'lk-requests-view',
  data() {
    return {
      recaptchaToken: null,
      isValid: false,
      manager: null,
      managerImg: null,
      phone: null,
      email: null,
      info: null,
      messages: [],

      infoForm: {
        action: 'lk/requests/message',
        disabledForm: false,
      },
      cmpForm: [
        {
          name: 'comment',
          type: 'textarea',
          value: '',
          hintField: this.$root.staticText.lk.requestsPlaceholder,
          error: false,
          valid: false,
          requiredField: true,
          pattern: /\S{2,}/i,
        },
      ],
      files: [],
    }
  },
  components: {
    'link-back-cmp': linkBack,
    'lk-file-cmp': lkFile,
    VueRecaptcha,
  },
  computed: {
    ...mapState('mobile', ['isMobile', 'isTablet']),
  },
  methods: {
    ...mapActions('modal', ['modalType_lkSuccessOpen', 'modalType_lkErrorOpen', 'modalType_requestContactOpen']),

    onCapchaRegister(recaptchaToken) {
      this.recaptchaToken = recaptchaToken
      if (this.isValid) {
        this.sendForm()
      }
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset()
    },
    errorCaptcha() {
      console.log('errorCaptcha')
    },

    setData(data) {
      this.manager = data.manager
      this.managerImg = data.managerImg
      this.phone = data.phone
      this.email = data.email
      this.info = data.info
      this.messages = data.messages
    },
    deleteFile(i) {
      this.files.splice(i, 1)
    },

    validate() {
      let is_valid = true

      for (let i = 0; i < this.cmpForm.length; i++) {
        this.cmpForm[i].error = false
        if (this.cmpForm[i].pattern !== '' && (!this.cmpForm[i].requiredField ? this.cmpForm[i].value !== '' : true)) {
          this.cmpForm[i].valid = true
          if (!this.cmpForm[i].pattern.test(this.cmpForm[i].value.trimEnd())) {
            this.cmpForm[i].error = true
            this.cmpForm[i].valid = false
            is_valid = false
          }
        }
      }
      this.isValid = is_valid
    },
    submitForm() {
      this.validate()

      if (this.isValid) {
        this.$refs.recaptcha.execute()
      }
    },
    sendForm() {
      this.infoForm.disabledForm = true
      let fd = new FormData()
      fd.append('recaptchaToken', this.recaptchaToken)
      fd.append('requestId', this.info.id)

      for (let i = 0; i < this.cmpForm.length; i++) {
        fd.append(this.cmpForm[i].name, this.cmpForm[i].value)
      }
      for (let i = 0; i < this.files.length; i++) {
        fd.append('files[]', this.files[i].file)
      }

      Vue.http
        .post(this.infoForm.action, fd)
        .then(response => response.json())
        .then(data => {
          this.infoForm.disabledForm = false
          if (data.success) {
            this.messages = data.messages
            this.clearFrom()
            setTimeout(() => {
              onScrollAnimate()
            }, 100)
          } else {
            this.openError(data)
          }
        })
        .catch(data => {
          this.infoForm.disabledForm = false
          this.openError(data)
        })
    },
    changeFile(e) {
      for (let i = 0; i < e.target.files.length; i++) {
        let name = e.target.files[i].name.split('.')
        let type = name.pop()
        this.files.push({
          name: name.join('.'),
          type: type,
          size: (e.target.files[i].size / (1024 * 1024)).toFixed(2),
          file: e.target.files[i],
        })
      }
    },
    openError(data) {
      let text = this.$root.staticText.modal.errorText
      if (data.errors && data.errors.length > 0) {
        let key = Object.keys(data.errors)[0]
        if (data.errors[key][0]) {
          text = data.errors[key][0]
        }
      }
      this.modalType_lkErrorOpen({
        title: this.$root.staticText.modal.errorTitle2,
        text: text,
        closeBthNone: true,
      })
    },
    focusForm(i) {
      this.cmpForm[i].error = false
    },
    clearFrom() {
      for (let i = 0; i < this.cmpForm.length; i++) {
        this.cmpForm[i].error = false
        this.cmpForm[i].valid = false
        this.cmpForm[i].value = ''
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    let url =
      process.env.NODE_ENV !== 'production' ? 'lk/requestsViewPage.json' : to.path.substring(1).replace(router.history.base, '')

    Vue.http.get(url, { params: to.query }).then(
      data => {
        this.setData(data.data)
        next()
      },
      data => {
        if (data.status === 403) {
          next({ name: 'E403' })
        } else {
          next({ name: 'E404' })
        }
      }
    )
  },
  beforeRouteEnter(to, from, next) {
    let url =
      process.env.NODE_ENV !== 'production' ? 'lk/requestsViewPage.json' : to.path.substring(1).replace(router.history.base, '')

    Vue.http.get(url, { params: to.query }).then(
      data => {
        next(vm => vm.setData(data.data))
      },
      data => {
        if (data.status === 403) {
          next({ name: 'E403' })
        } else {
          next({ name: 'E404' })
        }
      }
    )
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/pages/lk/requests/view/index.vue